"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import React from "react";
export function BackgroundBeams(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("pointer-events-none absolute inset-0 overflow-hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute -left-1/2 top-0 h-full w-full"><div className="absolute h-[200%] w-[80%] -translate-y-1/2 rounded-full opacity-20 blur-3xl" style={{
        background: "linear-gradient(180deg, var(--landing-accent-blue) 0%, transparent 50%)"
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute -right-1/2 top-1/4 h-full w-full"><div className="absolute h-[150%] w-[60%] -translate-y-1/2 rounded-full opacity-15 blur-3xl" style={{
        background: "linear-gradient(180deg, var(--landing-accent-red) 0%, transparent 50%)"
      }} /></div>;
    t4 = <div className="absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full opacity-10 blur-3xl bg-[var(--landing-accent-blue)]" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <div className={t1} aria-hidden={true}>{t2}{t3}{t4}</div>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}